/* ================================================== */
/* FUNCTIONS
/* ================================================== */


/* ================================================== */
/* DOCUMENT READY
/* ================================================== */

$(document).ready(function(){

	// -- Shops Cats --
	$('body.type--shops .article__categories li img').on('mouseover', function(e){
		$(this).parent('li').prevAll().addClass('inactive');
		$(this).parent('li').nextAll().addClass('inactive');
	});
	$('body.type--shops .article__categories li img').on('mouseleave', function(e){
		$(this).parent('li').prevAll().removeClass('inactive');
		$(this).parent('li').nextAll().removeClass('inactive');
	});


	// -- FAQ Achors --
	var url = window.location.href;
	var hash = url.substring(url.indexOf("#")+1);
	var query = '#summary-';
	if(url.indexOf(query) > -1) {
    $('#'+hash).attr('open', true);
  }

  // -- Medias Anchors --
  var mediasQuery = '#id-';
	if(url.indexOf(mediasQuery) > -1) {
		$('#'+hash).parents('details').attr('open', true).addClass('open');
		setTimeout(function(){
			$('html, body').animate({
				scrollTop:$('#'+hash).offset().top
			}, 'slow');
		},1000);
  }

});



/* ================================================== */
/* WINDOW RESIZE & ORIENTATIONCHANGE
/* ================================================== */

$(window).on('resize orientationchange', function(){
  if ($(window).width() < 767) {
    $('body').addClass('mobile tablet');
  } else {
    $('body').removeClass('mobile tablet');
  }
});